export default "assets/images/old-logo-dark-6f0bb1d1.svg";